import React from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import Container from '@mui/material/Container'

import { useLogout } from '~/client/hooks/auth'

export default function LogoutPage() {
  const [ searchParams ] = useSearchParams()
  const returnTo = searchParams.get('returnTo') || '/'
  const navigate = useNavigate()
  useLogout({
    callOnMount: true,
    onSuccess(){
      navigate(returnTo || '/')
    }
  })

  return <Container maxWidth="sm" sx={{p: 2}}>
    Logging out…
  </Container>
}
